module.exports = __webpack_public_path__ + "static/media/arrow-down-gray.7820494e.svg";